// extracted by mini-css-extract-plugin
module.exports = {"productGrid":"ti-z","centerLink":"ui-z","productSection":"vi-z","item":"wi-z","ctaButton":"xi-z"};